import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import { updateCalendarFolder, Calendar } from 'owa-calendar-cache';

export function updateCalendarFolderAndCache(
    calendar: Calendar,
    updatedCalendarFolder: CalendarFolder
): void {
    updateCalendarFolder(calendar, updatedCalendarFolder);
}
